import { useEffect } from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";

export const ModeToggle = ({ mode, onModeChange }) => {
  // Save mode to localStorage when it changes
  useEffect(() => {
    localStorage.setItem("preferredMode", mode);
  }, [mode]);

  return (
    <div className="relative bg-gradient-to-r from-[#143e6e] via-[#1f7db6] to-[#143e6e] py-4">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center gap-4">
          <p className="text-white text-sm hidden sm:block font-medium">Ich bin:</p>
          
          <div className="relative inline-flex rounded-2xl bg-white/10 backdrop-blur-xl p-1.5 border border-white/20 shadow-2xl">
            {/* Animated sliding indicator */}
            <motion.div
              className="absolute top-1.5 bottom-1.5 bg-white rounded-xl shadow-lg"
              animate={{
                left: mode === 'b2b' ? '6px' : '50%',
                right: mode === 'b2b' ? '50%' : '6px',
              }}
              transition={{
                type: "spring",
                stiffness: 300,
                damping: 30
              }}
            />

            {/* B2B Button */}
            <motion.button
              onClick={() => onModeChange('b2b')}
              className={`
                relative z-10 px-6 py-3 rounded-xl font-semibold transition-colors duration-300 flex items-center gap-2
                ${mode === 'b2b' ? 'text-[#143e6e]' : 'text-white hover:text-white/80'}
              `}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <Icons.Building2 size={18} />
              <span className="whitespace-nowrap">B2B Ankauf</span>
            </motion.button>

            {/* C2B Button */}
            <motion.button
              onClick={() => onModeChange('c2b')}
              className={`
                relative z-10 px-6 py-3 rounded-xl font-semibold transition-colors duration-300 flex items-center gap-2
                ${mode === 'c2b' ? 'text-[#143e6e]' : 'text-white hover:text-white/80'}
              `}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <Icons.User size={18} />
              <span className="whitespace-nowrap">Privat verkaufen</span>
            </motion.button>
          </div>
        </div>
      </div>
    </div>
  );
};
